import { genMessage } from '../helper';
// import elementPlus from 'element-plus/dist/locale/en.mjs';
// 修改文件

const modules = import.meta.glob('./en/*.ts', { eager: true });
export default {
	message: {
		...genMessage(modules, 'en'),
	},
	// dateLocale: elementPlus,
	dateLocaleName: 'En',
};
